import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 导入翻译资源
import enTranslation from './locales/en.json';
import zhCNTranslation from './locales/zh-cn.json';
import { globalConfig, LocaleKey } from './config/config';

export async function initI18n() {
    // 等待配置加载完成
    await globalConfig.waitForInit();
    
    // 现在当前语言
    let initLang = globalConfig.getItem(LocaleKey) || navigator.language.toLowerCase();
    initLang = initLang === "zh-cn" ? "zh-CN" : initLang;
    
    return i18n
        .use(initReactI18next)
        .init({
            resources: {
                en: { translation: enTranslation },
                'zh-CN': { translation: zhCNTranslation },
            },
            lng: initLang,
            fallbackLng: 'en',
            interpolation: {
                escapeValue: false, // React 已经防止 XSS
            },
        });
}

export const i18nInitPromise = initI18n();
export default i18n;